const checkFormValidation = ({ formField }) => {
  const { title, accountLivestreamId, hostId, operatorId, studioId, startedAt, endedAt } = formField;

  return !title || !accountLivestreamId.length || !startedAt || !endedAt || !hostId.length || !studioId || !operatorId.length;
};

export default checkFormValidation;
